import { render, staticRenderFns } from "./transmittals-table.vue?vue&type=template&id=82666dba"
import script from "./transmittals-table.vue?vue&type=script&lang=js"
export * from "./transmittals-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports